var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ScrollSelect", {
    attrs: {
      api: _vm.api,
      placeholder: _vm.$t("chooseText"),
      multiple: _vm.multiple,
      disabled: _vm.disabled,
      size: _vm.size,
      "page-size": _vm.pageSize,
      remote: _vm.remote,
      "default-params": _vm.defaultParams,
      "default-options": _vm.defaultOptions,
      "search-key": "name",
      "option-label": _vm.optionLabel,
      "option-value": _vm.optionValue,
      "option-enabled": "status",
      "res-key": "content",
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }